// Base
import React, { useState, useEffect, useMemo } from "react";

// Assets
import Visa from "@/assets/cards/visa-card.svg";
import Amex from "@/assets/cards/card-amex.svg";
import Diners from "@/assets/cards/diners-club.svg";
import Discover from "@/assets/cards/card-discover.svg";
import Elo from "@/assets/cards/card-elo.svg";
import Jcb from "@/assets/cards/card-jsb.svg";
import Maestro from "@/assets/cards/card-maestro.svg";
import Union from "@/assets/cards/card-union.svg";

const CreditCards: React.FC = () => {
  const imagesArray = [Visa, Maestro, Amex, Diners, Discover, Elo, Jcb, Union];
  const [tooltipActive, setTooltipActive] = useState(false);
  const [windowSize, setWindowSize] = useState<number>(
    typeof window !== "undefined" ? window.innerWidth : 0,
  );

  const isMobile = windowSize <= 768;

  const handleResize = () => setWindowSize(window.innerWidth);

  const visibleCards = useMemo(() => {
    if (windowSize >= 1071) {
      return { show: imagesArray.slice(0, 4), hide: imagesArray.slice(4) };
    }
    if (windowSize < 1071 && windowSize > 390) {
      return { show: imagesArray.slice(0, 4), hide: imagesArray.slice(4) };
    }
    return { show: imagesArray.slice(0, 2), hide: imagesArray.slice(2) };
  }, [windowSize]);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="relative ml-auto flex">
      {visibleCards.show.map((image, index) => (
        <img
          key={index}
          src={image}
          alt={`card-${index}`}
          className="mr-0.5 h-6"
        />
      ))}

      {visibleCards.hide.length > 0 && (
        <div
          className="border-cc-gray-4 relative flex h-6 w-[36px] cursor-pointer items-center justify-center rounded border bg-white text-sm font-medium"
          onClick={() => (isMobile ? setTooltipActive(!tooltipActive) : null)}
          onMouseEnter={() => !isMobile && setTooltipActive(true)}
          onMouseLeave={() => !isMobile && setTooltipActive(false)}
        >
          +{visibleCards.hide.length}
          <div
            className={`absolute right-[-17px] bottom-[30px] w-[172px] scale-90 transform rounded bg-black/90 transition-all duration-150 ${tooltipActive ? "" : "z-[-1] opacity-0"}`}
          >
            <div className="flex flex-wrap justify-between px-2 py-2">
              {visibleCards.hide.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`hidden-card-${index}`}
                  className="h-5"
                />
              ))}
            </div>
            <div className="absolute right-7 bottom-[-3px] h-0 w-0 rotate-[-45deg] border-[10px_0_0_10px] border-solid border-t-transparent border-r-transparent border-b-transparent border-l-black" />
          </div>
        </div>
      )}
    </div>
  );
};

export default CreditCards;
